export default "__VITE_ASSET__8ac9b4bc__"